<template>
	<div class="section" v-if="detailData">
		<div class="partner-fluid">
			<div class="partner-head">合作伙伴</div>
			<div class="partner-row">
				<div class="partner-photo"><img :src="detailData[0].thumb" alt="" /></div>
			</div  >
		</div>
	</div>
</template>
<script>
	import {index_notice_list_api,index_notice_details_api} from '@/api/index'
	export default {
		data() {
			return {
				detailData:null
			};
		},
		methods:{
			async getNotice(typeid) {
				let param = {
					type : typeid
				};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.detailData = res.data.data
					console.log(this.detailData)
				}
			},
		},
		mounted() {
			this.getNotice(5);
		}
	}
</script>

<style scoped>
	.partner-photo{
		margin-bottom: 16px;
	}
</style>